import editFill from "@iconify/icons-eva/edit-fill";
import disableFill from "@iconify/icons-eva/close-circle-fill";
import enableFill from "@iconify/icons-eva/checkmark-circle-2-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMemo } from "react";

export const PromoCodeActionMenu = ({ 
  id, 
  row, 
  onEdit, 
  onView, 
  onDelete, 
  onStatusChange 
}) => {
  const { is_active } = row;
  
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        action: () => onView && onView(row),
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        action: () => onEdit && onEdit(row),
      },
      ...(is_active ? [{
        id: "deactivate",
        title: "Deactivate",
        icon: disableFill,
        iconcolor: "red",
        action: () => onStatusChange && onStatusChange(row, false),
      }] : [{
        id: "activate",
        title: "Activate",
        icon: enableFill,
        iconcolor: "#48C13E",
        action: () => onStatusChange && onStatusChange(row, true),
      }]),
      // {
      //   id: "delete",
      //   title: "Delete",
      //   icon: deleteFill,
      //   iconcolor: "red",
      //   action: () => onDelete && onDelete(row),
      // },
    ],
    [id, is_active, row, onEdit, onView, onDelete, onStatusChange]
  );

  return <ActionsMenu menuList={actionList} />;
};
